import { useState } from "react";

const faqs = [
  {
    q: "51漫画APP是免费下载的吗？",
    a: "是的，51漫画APP完全免费下载使用。我们提供海量免费漫画资源，无需付费即可畅享阅读体验。您可以在本页面直接下载iOS或安卓版本的客户端。",
  },
  {
    q: "51漫画支持离线阅读吗？",
    a: "支持！51漫画APP支持全集离线下载阅读。您可以在有网络时将喜欢的漫画下载到本地，之后无需网络也能随时阅读，非常适合在地铁、飞机等无网络环境中使用。",
  },
  {
    q: "51漫画免费版下载和APP下载有什么区别？",
    a: "51漫画免费版下载指的是通过网页端直接阅读，而APP下载则是在手机客户端安装51漫画应用。APP客户端提供更流畅的阅读体验，支持离线下载、自动追更、个性化推荐等功能。",
  },
  {
    q: "51漫画的漫画资源更新频率如何？",
    a: "我们的漫画资源每日更新，确保您能够第一时间追更到最新的漫画章节。热门连载漫画通常会在原作发布后24小时内完成更新。",
  },
  {
    q: "如何在手机客户端安装51漫画？",
    a: "非常简单！点击本页面上的下载按钮，选择对应的iOS或安卓版本，下载完成后按照提示安装即可。安装过程只需1-2分钟，安装完成后即可开始阅读海量漫画。",
  },
  {
    q: "51漫画网站支持哪些设备？",
    a: "51漫画网站支持手机、平板、电脑等多种设备访问。除了APP客户端外，您也可以通过浏览器直接访问51漫画网站进行在线阅读，无需安装任何软件。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于51漫画的常见问题解答</p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </span>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-colors ${openIndex === index ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-500"}`}>
                  <i className={`text-sm transition-transform duration-200 ${openIndex === index ? "ri-subtract-line" : "ri-add-line"}`} />
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}